import { ArrowRight } from 'lucide-react';
import { type ReactElement, type ReactNode, useId } from 'react';
import { Link } from 'react-router';

interface OverviewSectionProps {
  readonly title: string;
  /** "전체 보기" 목적지. */
  readonly moreTo: string;
  readonly moreLabel: string;
  readonly children: ReactNode;
}

/** 홈의 하위 섹션 틀 — 굵은 제목과 오른쪽 "전체 보기 →", 아래 굵은 선(상품 상세 섹션 제목과 같은 결). */
export const OverviewSection = ({
  title,
  moreTo,
  moreLabel,
  children,
}: OverviewSectionProps): ReactElement => {
  const headingId = useId();

  return (
    <section aria-labelledby={headingId} className="flex flex-col gap-6">
      <div className="flex items-end justify-between gap-4 border-b border-foreground pb-4">
        <h2
          id={headingId}
          className="text-xl leading-tight font-bold tracking-[-0.02em] sm:text-2xl"
        >
          {title}
        </h2>
        <Link
          to={moreTo}
          className="inline-flex items-center gap-1 text-sm text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {moreLabel}
          <ArrowRight aria-hidden className="size-3.5" strokeWidth={1.5} />
        </Link>
      </div>
      {children}
    </section>
  );
};
